import type { IDelayedCaptureConfig } from './productV2.dto';

export interface PromotionDTO {
  name?: string;
  discount?: number;
  discountType?: PromotionType;
  effectiveDate?: Date;
  expiryDate?: Date;
  segments?: Array<string>;
  affectedProducts?: Array<string>;
  affectedProductsMode?: 'include' | 'exclude';
  affectedCategories?: Array<string>;
  postPurchaseCredit?: number;
  conditions?: IPromotionConditions; // ANY of the items need to be true
  delayedCapture?: boolean;
  // Partial pay-later config. When delayedCapture is enabled and this is set,
  // only this portion is deferred; otherwise the full amount is deferred (legacy).
  delayedCaptureConfig?: IDelayedCaptureConfig;
  firstOrderOnly?: boolean;
  status?: PromotionStatus;
  customers?: Array<string>;
  maxCustomerRedemptions?: number;
  cycles?: number;
}

export interface IPromotion extends PromotionDTO {
  _id: string;
  usageCount?: number;
  createdAt?: Date;
  updatedAt?: Date;
  promotionPeriod?: 'live' | 'upcoming' | 'past';
}

export class IPromotionConditions extends Array<IPromotionConditionCriteria> {
  // If ANY of these inner items evaluates to true, the promotion applies
  // Each inner item is a set of AND conditions
}

interface IPromotionConditionCriteria {
  productsMode?: 'include' | 'exclude';
  products: Array<{ id: string; minQty: number }>;
  categories: Array<{ id: string; minQty: number }>;
  minCartValue: number;
  minCartProductsQty: number;
}

export interface PromotionResponse {
  promotion: IPromotion;
  error?: string;
}

export enum PromotionType {
  PERCENT = 'percent',
  DOLLAR = 'dollar'
}

export enum PromotionStatus {
  ACTIVE = 'active',
  DISABLED = 'disabled'
}
